<!-- Vue Component -->

<template>
  <v-app>
    <left-bar></left-bar>
    <v-main>
      <v-snackbar
        app
        v-model="snackbar.state"
        top
        right
        :color="snackbar.color"
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.state = false">
            关闭
          </v-btn>
        </template>
      </v-snackbar>

      <v-container>
        <keep-alive>
          <router-view @snackbar="switchsnackbar"></router-view>
        </keep-alive>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import LeftBar from "@/components/content/LeftBar/LeftBar";
import login from "@/networker/login";
import EventBus from "@/tools/event-bus";
export default {
  data: function () {
    return {
      drawer: false,
      snackbar: {
        state: false,
        text: "TEXT",
        color: "blue",
      },
    };
  },
  components: {
    LeftBar,
  },
  methods: {
    switchsnackbar(e) {
      this.snackbar.state = true;
      this.snackbar.text = e.text;
      this.snackbar.color = e.color || this.snackbar.color;
    },
  },
  mounted() {
    //注册事件
    EventBus.$on("snackbar", (e) => {
      this.switchsnackbar(e);
    });
    //登录用户
    login.islogin().then((res) => {
      let data = res.data;
      if (data.status == 2000) {
        this.$store.commit("userLogin", data.data);
      } else {
        this.$store.commit("userLoginOut");
      }
    });
    // 夜间模式
    setTimeout(() => {
      this.$vuetify.theme.dark = window.localStorage.dark == "true" ? true : false;
    });
  },
};
</script>
<style type="text/css" media="screen"></style>
